// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"lawsuit-decision_wrapper__ZomHu","headingWithInfo":"lawsuit-decision_headingWithInfo__f1n0x","modalTrigger":"lawsuit-decision_modalTrigger__gVXnz"};